define('views/components/reseller/reseller_list',['require','views/base/list_view','views/components/reseller/reseller','text!templates/components/reseller/reseller_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/reseller/reseller');

    var temp = require("text!templates/components/reseller/reseller_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

